import { apiFetch } from './apiClient';



function fromApi(lead) {
  return {
    id:                lead.id,
    nome:              lead.nome,
    empresa:           lead.empresa           ?? '',
    cpf:               lead.cpf               ?? '',
    cnpj:              lead.cnpj              ?? '',
    telefone:          lead.telefone          ?? '',
    email:             lead.email             ?? '',
    servicosInteresse: lead.servicos_interesse ?? [],
    servicosDetalhes:  lead.servicos_detalhes  ?? [],
    anotacoes:         lead.observacoes        ?? '',
    negociacao:        lead.negociacao         ?? '',
    regimeTributario:  lead.regime_tributario  ?? '',
    anexosSimples:     lead.anexos_simples     ?? [],
    tiposAtividade:    lead.tipos_atividade    ?? [],
    porteEmpresa:      lead.porte_empresa      ?? '',
    setoresMovimento:  lead.setores_movimento  ?? { Folha: '', Fiscal: '', 'Contábil': '' },
    obrigacoes:        lead.obrigacoes         ?? [],
    status:            lead.status,
    dataCadastro:      lead.criado_em
      ? lead.criado_em.split('T')[0]
      : new Date().toISOString().split('T')[0],
    onboardProgresso:  lead.onboard_progresso ?? 0,
    onboardStatus:     lead.onboard_status    ?? 'pendente',
    codigoCliente:     lead.codigo_cliente    ?? '',
    clienteCriado:     lead.cliente_criado    ?? false,
    leadId:            lead.id,
    /* fluxo + negociação estruturada + dados do contrato (vazio = lead antigo) */
    tipoFluxo:            lead.tipo_fluxo            ?? '',
    honorariosMensais:    lead.honorarios_mensais    ?? '',
    valorServicoPontual:  lead.valor_servico_pontual ?? '',
    diaVencimento:        lead.dia_vencimento        ?? '',
    dataInicioServicos:   lead.data_inicio_servicos ? String(lead.data_inicio_servicos).slice(0, 10) : '',
    formaPagamento:       lead.forma_pagamento       ?? '',
    condicoesEspeciais:   lead.condicoes_especiais   ?? '',
    endereco:             lead.endereco              ?? {},
    representante:        lead.representante         ?? {},
    emailContrato:        lead.email_contrato        ?? '',
    pendenciasLevantadas: lead.pendencias_levantadas ?? null,
    pendenciasObs:        lead.pendencias_obs        ?? '',
    processosIds:         lead.processos_ids         ?? [],
  };
}

function toApi(form) {
  return {
    nome:               form.nome,
    empresa:            form.empresa,
    cpf:                form.cpf       ?? '',
    cnpj:               form.cnpj      ?? '',
    telefone:           form.telefone,
    email:              form.email,
    servicos_interesse: form.servicosInteresse ?? [],
    servicos_detalhes:  form.servicosDetalhes  ?? [],
    observacoes:        form.anotacoes,
    status:             form.status,
    negociacao:         form.negociacao        ?? '',
    regime_tributario:  form.regimeTributario  ?? '',
    anexos_simples:     form.anexosSimples     ?? [],
    tipos_atividade:    form.tiposAtividade    ?? [],
    porte_empresa:      form.porteEmpresa      ?? '',
    setores_movimento:  form.setoresMovimento  ?? {},
    obrigacoes:         form.obrigacoes        ?? [],
    codigo_cliente:     form.codigoCliente     ?? '',
    tipo_fluxo:            form.tipoFluxo            || null,
    honorarios_mensais:    form.honorariosMensais    ?? '',
    valor_servico_pontual: form.valorServicoPontual  ?? '',
    dia_vencimento:        form.diaVencimento        ?? '',
    data_inicio_servicos:  form.dataInicioServicos   ?? '',
    forma_pagamento:       form.formaPagamento       ?? '',
    condicoes_especiais:   form.condicoesEspeciais   ?? '',
    endereco:              form.endereco             ?? {},
    representante:         form.representante        ?? {},
    email_contrato:        form.emailContrato        ?? '',
    pendencias_levantadas: form.pendenciasLevantadas ?? null,
    pendencias_obs:        form.pendenciasObs        ?? '',
    processos_ids:         form.processosIds         ?? [],
  };
}

export async function listarLeads() {
  const data = await apiFetch('/leads');
  return data.map(fromApi);
}

export async function criarLead(form) {
  const data = await apiFetch('/leads', {
    method: 'POST',
    body: JSON.stringify(toApi(form)),
  });
  return fromApi(data);
}

export async function atualizarLead(id, form) {
  const data = await apiFetch(`/leads/${id}`, {
    method: 'PUT',
    body: JSON.stringify(toApi(form)),
  });
  return fromApi(data);
}

/* razão social e endereço pela Receita (mesma consulta do cadastro de clientes) */
export const consultarCnpjLead = (cnpj) => apiFetch(`/leads/consultar-cnpj/${String(cnpj).replace(/\D/g, '')}`);

export async function excluirLead(id) {
  await apiFetch(`/leads/${id}`, { method: 'DELETE' });
}
